<!-- <h4 class="title">Overdue Details</h4> -->
<br>
<div class="row">
    <!-- <div class="col-md-4">
        <div class="search-hero">
            <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
        </div>
    </div> -->
    <div class="col-md-5">
        <h5 class="form-lable">Loan Number: <span>1234568908765432</span></h5>
    </div>
    <div class="col-md-5">
        <h5 class="form-lable">Customer Name: <span>Mohammed Imthiyas</span></h5>
    </div>
    <!-- <div class="col-md-2 text-right">
        <button type="button" class="btn btn-primary mr-0" (click)="show2()">Add</button>
    </div> -->
    <div class="col-md-12">
        <div class="doc-table">
            <table class="det-t">
                <tr style="text-align: left;">
                    <th>DPD:</th>
                    <td><input type=""></td>
                </tr>
                <tr style="text-align: left;">
                    <th>Bucket/Cycles:</th>
                    <td><input type=""></td>
                </tr>
                <tr style="text-align: left;">
                    <th>No. of installments Overdue:</th>
                    <td><input type=""></td>
                </tr>
                <tr style="text-align: left;">
                    <th>Total Amount Overdue:</th>
                    <td><input type=""></td>
                </tr>
                <tr style="text-align: left;">
                    <th>Interest Overdue:</th>
                    <td><input type=""></td>
                </tr>
                <tr style="text-align: left;">
                    <th>Total Charges Overdue:</th>
                    <td><input type=""></td>
                </tr>
                <tr style="text-align: left;">
                    <th>Other Charges:</th>
                    <td><input type=""></td>
                </tr>
                <tr style="text-align: left;">
                    <th>Cheque Bounce Counter:</th>
                    <td><input type=""></td>
                </tr>
                <tr style="text-align: left;">
                    <th>Accrued Interest:</th>
                    <td><input type=""></td>
                </tr>
                <tr style="text-align: left;">
                    <th>Suspense Interest:</th>
                    <td><input type=""></td>
                </tr>
                <tr style="text-align: left;">
                    <th>Nomination Interest:</th>
                    <td><input type=""></td>
                </tr>

            </table>
        </div>
    </div>
</div>

<br>
